module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Hirschthal_AG-e1942b80d4444302219d36c63003557f.svg";